import {
  HomefieldIconChatConversation,
  HomefieldIconMobilePhone,
  HomefieldIconPlHelp,
} from '@dsg-tech/homefield-react-icons';
import { TextLink } from '@dsg-tech/homefield-react';
import FooterLogo from 'common/FooterLogo/FooterLogo';
import { checkStores } from 'utility/utility';
import './FooterMessaging.scss';
import { FooterMessagingV2 } from 'types';

interface Props {
  footerMessagingData: FooterMessagingV2[];
}
export default function FooterMessaging({ footerMessagingData }: Readonly<Props>) {
  const setFooterIcon = (icon: string, classes: string) => {
    switch (icon) {
      case 'questionMark':
        return <HomefieldIconPlHelp data-testid="questionMark" className={classes} />;
      case 'phone':
        return <HomefieldIconMobilePhone data-testid="phone" className={classes} />;
      case 'chat':
        return <HomefieldIconChatConversation data-testid="chat" className={classes} />;
      default:
        return <span data-testid="empty" className={`${classes} empty-icon`} />;
    }
  };

  return (
    <div
      data-testid="FooterMessaging"
      className="footerMessaging-container hmf-display-flex hmf-pb-m-xl">
      <div className="hmf-pl-s hmf-pb-m hmf-pb-l-0">
        <FooterLogo />
      </div>
      <div className="footerMessaging-container__content-container hmf-display-flex">
        {footerMessagingData.map((content) => (
          <div
            className="footerMessaging-container__content-wrapper hmf-display-flex"
            key={content.title}>
            {setFooterIcon(content.footerIcons, 'pl-messaging-icon hmf-mr-xxs hmf-ml-s hmf-ml-m-l')}
            <div className="footerMessaging-container__text-wrapper hmf-pr-l hmf-py-l hmf-py-m-0">
              <h2 className="footerMessaging-container__text-wrapper--title label-inverse-base  hmf-header-bold-s">
                {content.title}
              </h2>
              {content.description && (
                <TextLink variant="inverse" size="small" href={checkStores(content.link)}>
                  {content.description}
                </TextLink>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
